import React from 'react';

const ToolFooter = () => {
  return (
    <div className="mt-8 pt-6 border-t border-white/5 text-[10px] text-slate-500 italic leading-relaxed text-left w-full">
      Sources:{' '}
      <a href="https://www.legislation.gov.uk/uksi/2026/336/contents/made" target="_blank" rel="noopener noreferrer" className="underline hover:text-slate-400 transition-colors">MTD Regulations 2026</a>
      {' · '}
      <a href="https://www.gov.uk/hmrc-internal-manuals/business-income-manual/bim42100" target="_blank" rel="noopener noreferrer" className="underline hover:text-slate-400 transition-colors">HMRC BIM42100</a>
      {' · '}
      <a href="https://www.gov.uk/hmrc-internal-manuals/property-income-manual/pim2010" target="_blank" rel="noopener noreferrer" className="underline hover:text-slate-400 transition-colors">HMRC PIM2010</a>
    </div>
  );
};

export default ToolFooter;
